import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import HtmlContent from "../components/HtmlContent"
import Layout from "../components/Layout"
import CompanyContact from "../components/CompanyContact"

export class ContactPageTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = { email: "", name: "", message: "" }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  render() {
    const { title, overview, content } = this.props
    return (
      <section className="wrapper sidebar left">
        <div className="inner">
          <header className="major">
            <h2>{title}</h2>
            <p>{overview}</p>
          </header>
          <HtmlContent content={content} className="full-width" />
          <div className="content">
            <form
              action="https://formspree.io/martin@jklmltd.com"
              method="POST"
            >
              <div className="row gtr-uniform gtr-50">
                <input
                  type="text"
                  name="_replyto"
                  value={this.state.email}
                  style={{ display: "none" }}
                />
                <input
                  type="hidden"
                  name="_subject"
                  value="Message from website"
                />
                <input type="text" name="_gotcha" style={{ display: "none" }} />
                <div className="col-6 col-12-xsmall">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                    placeholder="Name"
                  />
                </div>
                <div className="col-6 col-12-xsmall">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    placeholder="Email"
                  />
                </div>
                <div className="col-12">
                  <textarea
                    name="message"
                    id="message"
                    placeholder="Enter your message"
                    rows="6"
                    value={this.state.message}
                    onChange={this.handleChange}
                  ></textarea>
                </div>
                <div className="col-12">
                  <ul className="actions">
                    <li>
                      <input
                        type="submit"
                        value="Send Message"
                        className="primary"
                      />
                    </li>
                    <li>
                      <input type="reset" value="Reset" />
                    </li>
                  </ul>
                </div>
                <div
                  class="gmap_canvas"
                  style={{ width: "100%", minHeight: "500px" }}
                >
                  <iframe
                    id="gmap_canvas"
                    src="https://maps.google.com/maps?q=213%20Lochend%20Road&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                    width="100%"
                    height="100%"
                  ></iframe>
                </div>
              </div>
            </form>
          </div>
          <div className="sidebar">
            <CompanyContact />
          </div>
        </div>
      </section>
    )
  }
}

ContactPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  overview: PropTypes.string,
  content: PropTypes.string,
}

const ContactPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout isHome={false}>
      <ContactPageTemplate
        title={post.frontmatter.title}
        overview={post.frontmatter.overview}
        content={post.html}
      />
    </Layout>
  )
}

export default ContactPage

ContactPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export const pageQuery = graphql`
  query ContactPage {
    markdownRemark(frontmatter: { templateKey: { eq: "contact-page" } }) {
      html
      frontmatter {
        title
        overview
      }
    }
  }
`
